export const createCharacterNotesStyles = (theme) => ({
  container: {
    margin: "0 auto",
    padding: "20px",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    padding: "20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },
  headerContent: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    margin: "0 0 8px 0",
    fontSize: "28px",
    color: theme.text,
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  subtitle: {
    margin: "0",
    color: theme.text,
    fontSize: "16px",
  },
  headerActions: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  newEntryButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 20px",
    backgroundColor: theme.primary,
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },

  noCharacterContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
    backgroundColor: "#fef2f2",
    border: "2px solid #fecaca",
    borderRadius: "12px",
    margin: "20px",
    maxWidth: "600px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  noCharacterIcon: {
    marginBottom: "16px",
  },
  noCharacterTitle: {
    color: theme.text,
    margin: "0 0 8px 0",
    fontSize: "24px",
  },
  noCharacterText: {
    color: theme.text,
    margin: "0",
    textAlign: "center",
  },
  newEntryModal: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  newEntryModalContent: {
    backgroundColor: theme.surface,
    borderRadius: "16px",
    padding: "0",
    width: "90%",
    maxWidth: "700px",
    maxHeight: "80vh",
    overflow: "auto",
    boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
    border: `2px solid ${theme.border}`,
  },
  newEntryModalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "24px 24px 16px 24px",
    borderBottom: `1px solid ${theme.border}`,
  },
  newEntryModalTitle: {
    margin: 0,
    fontSize: "24px",
    fontWeight: "600",
    color: theme.text,
  },
  modalCloseButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: theme.textSecondary,
    padding: "8px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
  },
  newEntryInputSection: {
    padding: "16px 24px",
  },
  newEntryTitle: {
    margin: "0 0 12px 0",
    fontSize: "18px",
    color: theme.text,
  },
  newEntryInput: {
    width: "100%",
    padding: "12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    fontSize: "16px",
    outline: "none",
    backgroundColor: theme.background,
    color: theme.text,
    marginBottom: "16px",
  },
  templateButtons: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    marginBottom: "16px",
  },
  templateButton: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 12px",
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
    color: theme.text,
    transition: "all 0.2s ease",
  },
  formActions: {
    display: "flex",
    gap: "8px",
  },
  cancelButton: {
    padding: "8px 16px",
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    cursor: "pointer",
    color: theme.text,
  },
  editForm: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    overflow: "hidden",
  },
  editHeader: {
    padding: "16px 20px",
    borderBottom: `1px solid ${theme.border}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  editTitleInput: {
    flex: 1,
    padding: "8px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "18px",
    fontWeight: "600",
    marginRight: "12px",
    backgroundColor: theme.background,
    color: theme.text,
  },
  editActions: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  viewModeButtons: {
    display: "flex",
    marginRight: "16px",
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    overflow: "hidden",
  },
  viewModeButton: {
    padding: "6px 12px",
    backgroundColor: theme.background,
    border: "none",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "500",
    color: theme.text,
    transition: "all 0.2s ease",
    borderRight: `1px solid ${theme.border}`,
  },
  viewModeButtonActive: {
    backgroundColor: theme.primary,
    color: "white",
  },
  saveButton: {
    padding: "8px 16px",
    backgroundColor: theme.success + "20",
    border: `1px solid ${theme.success}`,
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: theme.success,
    fontSize: "14px",
    fontWeight: "600",
    gap: "6px",
  },
  editCancelButton: {
    padding: "8px 16px",
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "600",
    gap: "6px",
    color: theme.text,
  },
  templateSection: {
    padding: "16px 20px",
    borderBottom: `1px solid ${theme.border}`,
    backgroundColor: theme.background,
  },
  editTemplateSectionTitle: {
    margin: "0 0 12px 0",
    fontSize: "14px",
    color: theme.text,
    fontWeight: "600",
  },
  editorContainer: {
    padding: "20px",
  },
  editorLoading: {
    height: "500px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.background,
    borderRadius: "8px",
    color: theme.textSecondary,
  },
  entriesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
    gap: "20px",
  },
  entryCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    overflow: "hidden",
    transition: "all 0.2s ease",
  },
  entryHeader: {
    padding: "16px 20px",
    borderBottom: `1px solid ${theme.border}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  entryTitleSection: {
    flex: 1,
  },
  entryTitle: {
    margin: "0 0 4px 0",
    fontSize: "18px",
    color: theme.text,
    fontWeight: "600",
  },
  entryDate: {
    margin: "0",
    fontSize: "12px",
    color: theme.text,
  },
  entryActions: {
    display: "flex",
    gap: "8px",
    marginLeft: "12px",
  },
  editEntryButton: {
    padding: "6px",
    backgroundColor: theme.secondary,
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: theme.text,
    transition: "all 0.2s ease",
  },
  deleteEntryButton: {
    padding: "6px",
    backgroundColor: theme.warning,
    border: "1px solid #fecaca",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: theme.text,
    transition: "all 0.2s ease",
  },
  duplicateEntryButton: {
    padding: "6px",
    backgroundColor: theme.primary,
    border: `1px solid #457880`,
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: theme.text,
    transition: "all 0.2s ease",
  },
  entryContent: {
    padding: "20px",
  },

  loadingContainer: {
    padding: "60px 20px",
    textAlign: "center",
    color: theme.textSecondary,
    fontSize: "16px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },
  emptyContainer: {
    padding: "60px 20px",
    textAlign: "center",
    color: theme.textSecondary,
    fontSize: "16px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },

  importExportSection: {
    backgroundColor: theme.surface,
    padding: "16px 20px",
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    marginTop: "20px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },
  importExportActions: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  exportButton: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 12px",
    backgroundColor: theme.success + "20",
    border: `1px solid ${theme.success}`,
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
    color: theme.success,
  },
  importLabel: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 12px",
    backgroundColor: theme.primary + "20",
    border: `1px solid ${theme.primary}`,
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
    color: theme.primary,
  },
  hiddenFileInput: {
    display: "none",
  },

  templateButtonHover: {
    backgroundColor: theme.primary + "10",
    borderColor: theme.primary,
  },
  editEntryButtonHover: {
    backgroundColor: theme.primary + "20",
    borderColor: theme.primary,
  },
  deleteEntryButtonHover: {
    backgroundColor: "#fee2e2",
    borderColor: "#dc2626",
  },
  newEntryButtonHover: {
    backgroundColor: theme.secondary,
    transform: "translateY(-1px)",
    boxShadow: `0 4px 12px ${theme.primary}40`,
  },
  templateSectionHeader: {
    textAlign: "center",
    marginBottom: "24px",
    padding: "0 24px",
  },
  templateSectionTitle: {
    margin: "0 0 8px 0",
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
  },
  templateSectionSubtitle: {
    margin: 0,
    fontSize: "14px",
    color: theme.textSecondary,
  },
  templateGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "16px",
    padding: "0 24px 24px 24px",
  },
  templateCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    textAlign: "center",
    minHeight: "140px",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
  },
  templateCardIcon: {
    width: "48px",
    height: "48px",
    borderRadius: "12px",
    backgroundColor: theme.primary + "15",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "12px",
    color: theme.primary,
    transition: "all 0.2s ease",
  },
  templateCardEmoji: {
    fontSize: "24px",
    lineHeight: 1,
  },
  templateCardContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  templateCardTitle: {
    margin: "0 0 6px 0",
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
  },
  templateCardDescription: {
    margin: 0,
    fontSize: "13px",
    color: theme.textSecondary,
    lineHeight: "1.4",
  },
});

// Helper function for backward compatibility
export const getCharacterNotesStyles = (theme) => createCharacterNotesStyles(theme);